import { z } from 'zod'

export const Season = z.enum(['spring', 'summer', 'autumn', 'winter'])
export type Season = z.infer<typeof Season>

const MONTH_DAY_PATTERN =
  /^(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|02-(?:0[1-9]|1\d|2[0-9]))$/

export const ClosedPeriod = z.object({
  from: z.string().regex(MONTH_DAY_PATTERN),
  to: z.string().regex(MONTH_DAY_PATTERN),
  reason: z.string().max(200).optional(),
})
export type ClosedPeriod = z.infer<typeof ClosedPeriod>

export const Seasonality = z.object({
  best_seasons: z.array(Season).max(4),
  closed_periods: z.array(ClosedPeriod).max(20),
})
export type Seasonality = z.infer<typeof Seasonality>
